<div class="ai-chat-popout allo-panel">
  @if (showChat()) {
    <header class="ai-chat-popout__header allo-header">
      <div class="header-left ai-chat-popout__brand">
        <div class="allo-logo">
          <div class="allo-icon ai-chat-popout__logo" aria-hidden="true">
            <img
              src="assets/img/allo-ai-logo.svg"
              alt=""
              width="24"
              height="24" />
          </div>
          <span class="allo-title ai-chat-popout__name">
            {{ 'GNR_AI_ALLO' | translate }}
          </span>
        </div>
      </div>
      <div class="header-right ai-chat-popout__actions">
        <button
          class="header-btn new-chat ai-chat-popout__new-btn"
          [class.header-btn--active]="selectedChatId() === null"
          type="button"
          (click)="startNewChat()"
          [attr.aria-label]="'GNR_NEW_CHAT' | translate"
          [matTooltip]="'GNR_NEW_CHAT' | translate"
          matTooltipPosition="below">
          <mat-icon>add</mat-icon>
          <span class="header-btn__label">{{
            'GNR_NEW_CHAT' | translate
          }}</span>
        </button>
        <button
          class="header-btn ai-chat-popout__history-btn"
          type="button"
          (click)="toggleHistory()"
          [class.header-btn--active]="showHistory()"
          [attr.aria-label]="'GNR_HISTORY' | translate"
          [matTooltip]="'GNR_HISTORY' | translate"
          matTooltipPosition="below">
          <mat-icon>history</mat-icon>
          <span class="header-btn__label">{{ 'GNR_HISTORY' | translate }}</span>
        </button>
      </div>
    </header>

    @if (showHistory()) {
      <div class="ai-chat-popout__history-dropdown history-dropdown">
        @if (chatHistory().length === 0) {
          <span class="ai-chat-popout__history-empty">
            {{ 'GNR_NO_CHATS' | translate }}
          </span>
        } @else {
          <div class="ai-chat-popout__history-list history-list">
            @for (item of visibleHistory(); track item.id) {
              <div
                class="history-item"
                [class.history-item--active]="selectedChatId() === item.id"
                [class.history-item--editing]="editingChatId() === item.id">
                @if (editingChatId() === item.id) {
                  <input
                    class="history-item-title-input"
                    type="text"
                    [value]="editingTitle()"
                    (input)="onEditingTitleInput($event)"
                    (blur)="saveEditTitle()"
                    (keydown.enter)="saveEditTitle(); $event.preventDefault()"
                    (keydown.escape)="
                      cancelEditTitle(); $event.preventDefault()
                    "
                    (click)="$event.stopPropagation()" />
                } @else {
                  <div class="history-item__row" (click)="selectChat(item.id)">
                    <span class="history-item-title">
                      {{ item.title || ('GNR_AI_CHAT' | translate) }}
                    </span>
                    <button
                      class="history-item-edit"
                      type="button"
                      (click)="startEditTitle(item); $event.stopPropagation()"
                      aria-label="Edit chat name">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                  <span class="history-item-preview">
                    {{
                      item.preview ||
                        (item.updatedAt
                          ? (item.updatedAt | date: 'medium')
                          : '')
                    }}
                  </span>
                }
              </div>
            }
          </div>
          @if (hasMoreHistory()) {
            <button
              class="view-more-btn"
              type="button"
              (click)="showMoreHistory()">
              View more
            </button>
          }
        }
      </div>
    }

    <div class="ai-chat-popout__body chat-body">
      @for (session of [chatSessionKey()]; track session) {
        <qt-ai-chat
          [windowId]="session"
          [chatId]="selectedChatId()"
          [lazySubscribe]="lazyChatSubscribe()"></qt-ai-chat>
      }
    </div>
  } @else {
    <div class="ai-chat-popout__empty">
      {{ 'GNR_AI_CHAT' | translate }}
    </div>
  }
</div>
